"use strict";
import { __exports as c } from "./index.es282.js";
import { __require as y } from "./index.es249.js";
import { __require as U } from "./index.es273.js";
var l;
function x() {
  return l ? c : (l = 1, (function(h) {
    Object.defineProperty(h, "__esModule", {
      value: !0
    });
    function m(e, t) {
      for (var o in t) Object.defineProperty(e, o, {
        enumerable: !0,
        get: t[o]
      });
    }
    m(h, {
      formatUrl: function() {
        return p;
      },
      formatWithValidation: function() {
        return q;
      },
      urlObjectKeys: function() {
        return u;
      }
    });
    const _ = /* @__PURE__ */ (/* @__PURE__ */ y())._(U()), d = /https?|ftp|gopher|file/;
    function p(e) {
      let { auth: t, hostname: o } = e, a = e.protocol || "", n = e.pathname || "", f = e.hash || "", s = e.query || "", r = !1;
      t = t ? encodeURIComponent(t).replace(/%3A/i, ":") + "@" : "", e.host ? r = t + e.host : o && (r = t + (~o.indexOf(":") ? "[" + o + "]" : o), e.port && (r += ":" + e.port)), s && typeof s == "object" && (s = String(_.urlQueryToSearchParams(s)));
      let i = e.search || s && "?" + s || "";
      return a && !a.endsWith(":") && (a += ":"), e.slashes || (!a || d.test(a)) && r !== !1 ? (r = "//" + (r || ""), n && n[0] !== "/" && (n = "/" + n)) : r || (r = ""), f && f[0] !== "#" && (f = "#" + f), i && i[0] !== "?" && (i = "?" + i), n = n.replace(/[?#]/g, encodeURIComponent), i = i.replace("#", "%23"), "" + a + r + n + i + f;
    }
    const u = [
      "auth",
      "hash",
      "host",
      "hostname",
      "href",
      "path",
      "pathname",
      "port",
      "protocol",
      "query",
      "search",
      "slashes"
    ];
    function q(e) {
      return process.env.NODE_ENV === "development" && e !== null && typeof e == "object" && Object.keys(e).forEach((t) => {
        u.includes(t) || console.warn("Unknown key passed via urlObject into url.format: " + t);
      }), p(e);
    }
  })(c), c);
}
export {
  x as __require
};
//# sourceMappingURL=index.es252.js.map
